module.exports = __webpack_public_path__ + "static/img/lunBo2.33792f30.png";